import React, { ReactNode } from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import Button from 'components/lib/Button';
import { useAppSelector } from 'store/hook';

const CommunityName = styled.div`
  font-size: 14px;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  background: linear-gradient(315deg, #5f5fff, #f05fff 50%, #ff5b98 0%);
`;

const RightSlot = styled.div`
  margin-right: 10px;
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  align-self: flex-end;
  padding-bottom: 6px;
  margin-right: 10px;
`;

type Props = {
  onCreatePlan?: () => void;
  rightSlot?: ReactNode;
};

const ActionPlansHeader = ({ onCreatePlan, rightSlot }: Props) => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  return (
    <div data-test-id="action-plans-header">
      <Header
        title="Action Plans"
        breadcrumbs={
          <CommunityName data-test-id="action-plans-header-community-name">
            {selectedCommunity?.name || ''}
          </CommunityName>
        }
        iconComponent={
          <IconContainer data-test-id="action-plans-header-icon">
            <img src="/icons/checklist-black.svg" alt="checklist" height="20px" width="20px" />
          </IconContainer>
        }
      >
        {(rightSlot || onCreatePlan) && (
          <HeaderActions>
            {rightSlot && <RightSlot>{rightSlot}</RightSlot>}
            {onCreatePlan && (
              <StyledButton
                type={'primary'}
                icon={<img src="/icons/add.svg" height={22} width={22} alt="add" />}
                onClick={onCreatePlan}
                data-test-id="action-plans-create-button"
              >
                Create Plan
              </StyledButton>
            )}
          </HeaderActions>
        )}
      </Header>
    </div>
  );
};

export default ActionPlansHeader;
